module.exports = __webpack_public_path__ + "images/195f873f9c3776ce01055b52ac03a2be.png";